import { NavLink } from "react-router-dom";
import styles from "./CustomNavLink.module.css";

const CustomNavLink = ({ to, children }) => {
  return (
    <NavLink to={to} 
      className={({ isActive, isPending, isTransitioning }) => isActive ? `${styles.link} ${styles.active}` : `${styles.link} ${styles.default}`}
    >
      {children}
    </NavLink>
  );
};

export default CustomNavLink;
